import CreateResourceInteractor from "../../core/interactor/app/crud/CreateResourceInteractor";
import { IOrganisationIndex } from "../model/OrganisationIndex";
import OrganisationIndexMapper from "../service/OrganisationIndexMapper";
import OrganisationIndexParamMapper from "../service/OrganisationIndexParamMapper";

export default class CreateOrganisationIndexInteractor {
  private createResource: CreateResourceInteractor<IOrganisationIndex>;

  constructor({ createResource }: any) {
    this.createResource = createResource;
  }

  async execute(model: IOrganisationIndex) {
    return this.createResource.execute(
      `organisations/${model.organisationId}/indexes`,
      OrganisationIndexMapper,
      OrganisationIndexParamMapper,
      model,
      undefined,
      false
    );
  }
}
